import { useState } from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import DialogForm from "../Dialog/DialogForm";
import { isEmpty, isEmail } from "../../utils/validators";

const RequireValuesForm = ({ open, userOwnProp, onChange, onClose, acceptLabel }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: userOwnProp.email || "",
    schoolCode: userOwnProp.schoolCode || ""
  })
  const [invalidInput, setInvalidInput] = useState({
    email: "",
    schoolCode: ""
  })

  const handleOnAccept = () => {
    if (isEmpty(form.email) || !isEmail(form.email)) {
      setInvalidInput(prev => ({...prev, email: "Correo electronico es invalido"}));
    } else if (isEmpty(form.schoolCode)) {
      setInvalidInput(prev => ({...prev, schoolCode: "Numero de colegio es obligatorio"}));
    } else {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        onChange(form);
      }, 960);
    }
  };

  const handleOnChange = (e) => {
    const value = e.target.value;
    const name = e.target.name

    if (setInvalidInput[name]) {
      setInvalidInput(prev => ({
        ...prev,
        [name]: ""
      }))
    }

    setForm(prev => ({
      ...prev,
      [name]: value
    }))
  };

  return (
    <DialogForm
      onAccept={handleOnAccept}
      onClose={onClose}
      open={open}
      title="Campos requeridos"
      message="verificar si los campos requeridos estan correcto, si esta incorrecto favor de corregir."
      acceptLabel={acceptLabel}
      isLoading={loading}
    >
      <TextField
        required
        name="email"
        value={form.email}
        label="Email"
        margin="normal"
        fullWidth
        onChange={handleOnChange}
        error={!!invalidInput.email}
        autoFocus
        helperText={invalidInput.email}
        // className={styles.inputMedium, styles.inputRightSpace}
        variant="standard"
      />
      <TextField
        required
        name="schoolCode"
        value={form.schoolCode}
        label="Código de Colegio"
        margin="normal"
        fullWidth
        onChange={handleOnChange}
        error={!!invalidInput.schoolCode}
        helperText={invalidInput.schoolCode}
        // className={styles.inputMedium, styles.inputRightSpace}
        variant="standard"
      />
    </DialogForm>
  );
};

RequireValuesForm.propTypes = {
  open: PropTypes.bool,
  userOwnProp: PropTypes.shape({
    email: PropTypes.string,
    schoolCode: PropTypes.string
  }),
  onChange: PropTypes.func,
};

export default RequireValuesForm;
